export function tryCancelPromise(p: CancellablePromise<any> | undefined | null) {
    if (p && typeof p.cancel === 'function') {
        p.cancel();
    }
}
